import { get } from 'lodash';
import { instance } from './api.service';

export const getOperationsLog = async (filters = {}) => {
  const params = {};
  Object.keys(filters).forEach((k) => {
    const v = filters[k];
    if (v !== undefined && v !== null && v !== '') { params[k] = v; }
  });
  const resp = await instance.get('/operationslog', { params });
  return get(resp, 'data.data', []);
};

export const createOperationsLogEntry = async (entry) => {
  const resp = await instance.post('/operationslog/create', { entry });
  return get(resp, 'data.data', null);
};

export const updateOperationsLogEntry = async (entry) => {
  const resp = await instance.post('/operationslog/update', { entry });
  return get(resp, 'data.data', null);
};

export const deleteOperationsLogEntry = async (entry) => {
  const resp = await instance.post('/operationslog/delete', { entry });
  return get(resp, 'data.data', null);
};

export const importOperationsLogEntries = async (rows) => {
  const resp = await instance.post('/operationslog/import', { rows });
  return get(resp, 'data.data', null);
};

export const getOperationsLogOrderIds = async () => {
  const resp = await instance.get('/operationslog/orderids');
  return get(resp, 'data.data', []);
};
